'use strict';

var React = require('react');
var reactUtils = require('@sravni/react-utils');
var Divider_module = require('../styles/Divider.module.less.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

/**
 * @description A divider line separates different content
 *
 * @component
 * @example
 * ```jsx
 * <Divider />
 * ```
 */
const Divider = React__namespace.forwardRef((props, ref) => {
    const { size, className, ...restProps } = props;
    const cx = reactUtils.useStyles(Divider_module.default);
    const classNames = cx(className, 'container', {
        [`size-${size}`]: size,
    });
    return React__namespace.createElement("div", { ref: ref, "data-qa": "Divider", className: classNames, ...restProps });
});
Divider.defaultProps = {};
Divider.displayName = 'Divider';

exports.Divider = Divider;
//# sourceMappingURL=Divider.js.map
